<template>
  <section class="get-service">
    <v-container class="mx-auto">
      <v-col cols="12" class="mx-auto">
        <h2 class="section-title">
          AloKasko Uzmanlarından Hasar Danışmanlık Hizmeti Nasıl Alınır?
        </h2>
      </v-col>
      <v-row
        no-gutters
        class="get-service--content justify-center justify-lg-space-between mt-10"
      >
        <v-col
          cols="4"
          class="d-none d-lg-block get-service--content--illustrator"
        ></v-col>
        <v-col
          cols="10"
          lg="7"
          class="get-service--content--desc text-center text-lg-left"
        >
          <p>
            Uzman kadromuz hasar anınızda da her daim yanınızdadır. Satın
            aldığınız poliçe kapsamında gerçekleşen hasarlarınız için hasar
            uzmanlarımızdan destek almanız çok kolay!
          </p>
          <p>
            İster yeni oluşan hasar ister daha önceden meydana gelmiş ve
            çözümlenememiş, ödemesini alamadığınız hasarlarınız olsun her daim
            uzmanlarımızdan yardım alabilirsiniz.
          </p>
          <p>
            7/24 hizmet almak için
            <span class="get-service--content--phone">0216 371 67 77</span> nolu
            telefonu arayabilir ya da sayfamızda yer alan formdan bilgilerinizi
            bize iletebilirsiniz.
          </p>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {}
</script>

<style></style>
